import App from './App'

export { App }



// WEBPACK FOOTER //
// ./src/app/index.js